import { DeleteIcon } from '@/components/_common';

interface Props {
  onClick: VoidFunction;
  disabled: boolean;
}

export default function RemoveBenefitTable(props: Props) {
  return <DeleteIcon onClick={props.onClick} disabled={props.disabled} />;
}
